import React, { useEffect, useState } from "react";
import { Typography, Box, Button, Tabs, Tab, IconButton, Dialog, DialogTitle, DialogContent, TextField, InputAdornment, MenuItem, CircularProgress, DialogActions, Tooltip, RadioGroup, FormControlLabel, Radio, Chip, Autocomplete } from "@mui/material";
import { Visibility, Event, Edit, EventRepeat, Delete } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import DefaultLayout from '../../../Components/DefaultLayout';
import Backdrop from '@mui/material/Backdrop';
import Freez from '../../../Components/Loader/Loader'
import swal from "sweetalert";
import { fetchData, postFormData } from "../../../redux/apiSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers";
import moment from 'moment-timezone';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
const Campaigns = () => {
    const navigate = useNavigate();
    const [freez, setFreez] = React.useState(false);
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    const pstDate = moment().tz('America/Los_Angeles'); // current PST time
    const [selectedDate, setSelectedDate] = useState(dayjs(pstDate.format('YYYY-MM-DD')));
    const [selectedTime, setSelectedTime] = useState(dayjs(pstDate.format('YYYY-MM-DD HH:mm:ss')));
    const [savedEmails, setSavedEmails] = useState([]);
    const [sentEmails, setSentEmails] = useState([])
    const [selectedRows, setSelectedRows] = useState([]);
    const savedEmailscolumns = [
        { field: "template_name", headerName: "Template Name", flex: 1, minWidth: 150, valueGetter: (params) => params.row.template_name || "N/A" },
        { field: "subject", headerName: "Subject", flex: 1, minWidth: 150, valueGetter: (params) => params.row.subject || "N/A" },
        { field: "created_at", headerName: "Created At", flex: 1, minWidth: 200, valueFormatter: (params) => moment.utc(params.value).tz("America/Los_Angeles").format("MM-DD-YYYY hh:mm A") },
        { field: "updated_at", headerName: "Updated At", flex: 1, minWidth: 200, valueFormatter: (params) => moment.utc(params.value).tz("America/Los_Angeles").format("MM-DD-YYYY hh:mm A") },
        { field: "user", headerName: "User Name", flex: 1, minWidth: 150, valueGetter: (params) => params.row.user?.name || "N/A" },
        {
            field: "actions", headerName: "Action", flex: 1, minWidth: 200, sortable: false,
            renderCell: (params) => (
                <Box display="flex" justifyContent="center" gap={2}>
                    {[{ icon: <Visibility />, label: "View", onClick: () => handleOpenDialog(params.row) },
                    { icon: <Edit />, label: "Edit", onClick: () => handleEdit(params.row) },
                    { icon: <Delete />, label: "Delete", onClick: () => handleDelete(params.row) }]
                        .map(({ icon, label, onClick }, index) => (
                            <Tooltip key={index} title={label}>
                                <IconButton onClick={onClick ? onClick : undefined}>
                                    {icon}
                                </IconButton>
                            </Tooltip>
                        ))}
                </Box>
            )
        }
    ];
    const handleEdit = (email) => {
        navigate("/email-editor", { state: { content: email.content } });
    };
    const handleDelete = (row) => {
        setConfirmMessage(`Are you sure you want to delete "${row.template_name || "this template"}"?`);
        setConfirmAction(() => async () => {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate('/login');
                return;
            }
            const formData = new FormData();
            formData.append("templateId", row.id);
            try {
                const res = await dispatch(postFormData({ apiUrl: "/template/delete", formData })).unwrap();
                if (res?.success) {
                    swal("Deleted!", "Template deleted successfully!", "success");
                    setSavedEmails(prev => prev.filter(item => item.id !== row.id));
                    setSelectedRows(prev => prev.filter(item => item.id !== row.id));
                } else {
                    swal("Error!", res?.message?.message || res?.message || "Failed to delete the template.", "error");
                }
            } catch (err) {
                swal("Error!", err?.message || err?.error?.message || "An error occurred.", "error");
            }
        });
        setOpenConfirm(true);
    };

    const sentEmailsColumns = [
        { field: "name", headerName: "Name", flex: 1, minWidth: 200, valueGetter: (params) => params.row.user?.name || "N/A" },
        {
            field: "status", headerName: "Status", flex: 1, minWidth: 250,
            renderCell: (params) => {
                const isSent = params.row.mail_sent === 1;
                const status = isSent ? "Sent" : "Scheduled";
                const time = isSent ? params.row.created_at : params.row.schedule_time;
                let formattedDate = "Invalid Date";
                if (time) {
                    formattedDate = isSent
                        ? moment.utc(time).tz("America/Los_Angeles").format("MM-DD-YYYY HH:mm")
                        : moment.tz(time, "America/Los_Angeles").format("MM-DD-YYYY HH:mm");
                }
                return (
                    <Box display="flex" flexDirection="column" alignItems="flex-start" gap={0.5}>
                        <Box
                            sx={{
                                color: isSent ? "#2A9005" : "#FFA500",
                                background: isSent ? "#D8F2D8" : "#FFF3CD",
                                borderRadius: "2px",
                                padding: "4px 10px",
                            }}
                        >
                            <Typography variant="caption" fontWeight="bold">{status}</Typography>
                        </Box>
                        <Typography variant="caption" color="textSecondary">{formattedDate}</Typography>
                    </Box>
                );
            }
        },
        {
            field: "recipients", headerName: "Recipients", flex: 1, minWidth: 150,
            renderCell: (params) => {
                const count = params.row.no_of_recipients ?? 0;
                return (
                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                        <Tooltip title="View Recipients">
                            <IconButton
                                size="small"
                                onClick={() => handleViewRecipients(params.row)}
                            >
                                <Visibility fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Typography variant="caption" color="textSecondary">{count}</Typography>
                    </Box>
                );
            }
        },
        {
            field: "analytics", headerName: "Analytics", flex: 1, minWidth: 200,
            renderCell: (params) => {
                const opens = params.row.viewed_count ?? 0;
                const clicks = params.row.clicked_count ?? 0;
                const total = params.row.no_of_recipients ?? 0;
                const openPercent = total ? ((opens / total) * 100).toFixed(1) : "0.0";
                const clickPercent = total ? ((clicks / total) * 100).toFixed(1) : "0.0";
                return (
                    <Box display="flex" gap={4}>
                        {/* Opens */}
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            sx={{
                                cursor: 'default',
                                '& .hover-value': { display: 'none' },
                                '&:hover .default-value': { display: 'none' },
                                '&:hover .hover-value': { display: 'block' },
                            }}
                        >
                            <Typography className="default-value" fontWeight="bold">{openPercent}%</Typography>
                            <Typography className="hover-value" fontWeight="bold">{opens}</Typography>
                            <Typography variant="caption" color="textSecondary">Opens</Typography>
                        </Box>

                        {/* Clicks */}
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            sx={{
                                cursor: 'default',
                                '& .hover-value': { display: 'none' },
                                '&:hover .default-value': { display: 'none' },
                                '&:hover .hover-value': { display: 'block' },
                            }}
                        >
                            <Typography className="default-value" fontWeight="bold">{clickPercent}%</Typography>
                            <Typography className="hover-value" fontWeight="bold">{clicks}</Typography>
                            <Typography variant="caption" color="textSecondary">Clicks</Typography>
                        </Box>
                    </Box>
                );
            }
        },
        {
            field: "actions", headerName: "Action", flex: 1, minWidth: 200,
            renderCell: (params) => {
                const { mail_sent } = params.row;  //  TO SHOW action buttons dynamically
                const actions = [
                    {
                        icon: <Visibility />,
                        tooltip: "View Email Content",
                        onClick: handleOpenDialog
                    },
                    // {
                    //     icon: <Edit />,
                    //     tooltip: "Edit",
                    //     onClick: handleEditCampaignEmail
                    // },
                    {
                        icon: mail_sent ? <EventRepeat /> : <Event />,
                        tooltip: mail_sent ? "Reschedule" : "Schedule",
                        onClick: handleSendEmailClick
                    },
                ];
                return (
                    <Box display="flex" justifyContent="center" gap={2}>
                        {actions.map(({ icon, tooltip, onClick }, index) => (
                            <Box key={index} display="flex" flexDirection="column" alignItems="center">
                                <Tooltip title={tooltip}>
                                    <IconButton onClick={() => onClick(params.row)}>
                                        {icon}
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        ))}
                    </Box>
                );
            }
        }
    ];
    // const handleEditCampaignEmail = (row) => {
    //     navigate("/email-editor", {
    //         state: { content: row.email_templates?.content || "", selectedReport: row, },
    //     });
    // };
    const [viewCols, setViewCols] = useState([]);
    const [viewRows, setViewRows] = useState([]);
    const [isViewRecipientsOpen, setIsViewRecipientsOpen] = useState(false);
    const handleViewRecipients = (report) => {
        if (!report?.file) {
            swal("Error!", "No file data found in the report.", "error");
            return;
        }
        try {
            const lines = atob(report.file).trim().split("\n");
            const headers = lines[0].split(",").map(h => h.trim());
            const rows = lines.slice(1).map((line, index) => {
                const values = line.split(",");
                const row = { id: index };
                headers.forEach((h, i) => (row[h] = values[i]?.trim()));
                return row;
            });
            setViewCols(headers.map(h => ({
                field: h, headerName: h, flex: 1, minWidth: 200, renderCell: (params) => (
                    <Box sx={{ wordBreak: "break-word", whiteSpace: "normal", overflow: "hidden" }}>
                        {params.value || "N/A"}
                    </Box>
                )
            })));
            setViewRows(rows);
            setIsViewRecipientsOpen(true);
        } catch (error) {
            console.log("Error decoding and parsing file:", error);
            swal("Error!", "Failed to decode recipient data.", "error");
        }
    };
    const dispatch = useDispatch();
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const handleOpenDialog = (email) => {
        console.log("Selected Row:", email);
        console.log("Email Template:", email.email_templates);
        // FOR saved email template set content 
        if (email.email_templates?.content) {
            setSelectedEmail({
                content: email.email_templates.content,  // for saved email templates
            });
        } else {
            setSelectedEmail(email);  // For other emails
        }

        setOpenDialog(true);
    };
    const [openEmailPopup, setOpenEmailPopup] = useState(false);
    const [emailCsvData, setEmailCsvData] = useState({});
    const [emailCsvColumns, setEmailCsvColumns] = useState({});
    const [selectedReport, setSelectedReport] = useState(null);
    const handleSendEmailClick = (email) => {
        setOpenEmailPopup(true);
        setSelectedEmail(email);
        try {
            const decodedText = atob(email.file);
            console.log("Decoded CSV Data:", decodedText);
            const rows = decodedText
                .split("\n")
                .map(row => row.trim())
                .filter(row => row)
                .map(row => row.split(","));
            const headers = rows[0];
            const data = rows.slice(1).map((row, index) => ({
                id: index + 1,
                ...Object.fromEntries(row.map((val, i) => [headers[i], val]))
            }));
            const columns = headers.map(header => ({
                field: header,
                headerName: header,
                flex: 1
            }));
            setEmailCsvData(prev => ({
                ...prev,
                [email.id]: data,
            }));
            setEmailCsvColumns(prev => ({
                ...prev,
                [email.id]: columns,
            }));
            setCsvRows(data);
            setCsvColumns(columns);

        } catch (error) {
            console.error("Error decoding CSV:", error.message);
        }
    };
    const [openScheduleSection, setOpenScheduleSection] = useState(false);
    const handleScheduleLaterClick = () => {
        setOpenScheduleSection(true); // Show the date/time 
    };
    useEffect(() => {
        if (activeTab === 1) {
            fetchSavedEmails();
        } else if (activeTab === 0) {
            fetchSentEmails();
        }
    }, [activeTab]);

    const fetchSavedEmails = async () => {
        let token = localStorage.getItem("token");
        if (!token) {
            navigate('/login');
            return;
        }
        handleFreezStart();
        const apiUrl = "/template/all";
        try {
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            console.log(res);

            if (res && res.success === true) {
                setSavedEmails(res.data);
            } else {
                swal("Error!", "Something went wrong!", "error");
            }
        } catch (error) {
            console.log("Error fetching saved emails:", error);
            swal("Error!", "Failed to fetch saved emails", "error");
        } finally {
            handleFreezStop();
        }
    };
    const fetchSentEmails = async () => {
        let token = localStorage.getItem("token");
        if (!token) {
            navigate('/login');
            return;
        }
        handleFreezStart();
        const apiUrl = "/sentEmails/all";

        try {
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            console.log(res);

            if (res && res.success === true) {
                setSentEmails(res.data);
            } else {
                swal("Error!", "Something went wrong!", "error");
            }
        } catch (error) {
            console.log("Error fetching sent emails:", error);
            swal("Error!", "Failed to fetch sent emails", "error");
        } finally {
            handleFreezStop();
        }
    };
    const [recipientType, setRecipientType] = useState("report");
    const [manualEmails, setManualEmails] = useState([]);
    const [isSendingNow, setIsSendingNow] = useState(false);
    const [isScheduling, setIsScheduling] = useState(false);
    const handleSendEmail = async (scheduleLater = false, email) => {
        if (isSendingNow || isScheduling) {
            swal({
                title: "Action in Progress", text: "Please wait for the current action to complete.",
                icon: "info", timer: 2000, buttons: false,
            });
            return;
        } // loading state
        const confirmed = await swal({
            title: scheduleLater ? "Confirm Schedule" : "Confirm Send",
            text: scheduleLater
                ? "Do you want to schedule this email?"
                : "Do you want to send this email now?",
            icon: "warning",
            buttons: ["Cancel", "Yes"],
            dangerMode: true,
        });
        if (!confirmed) return;
        if (scheduleLater) {
            setIsScheduling(true);
        } else {
            setIsSendingNow(true);
        }
        const apiUrl = "/sentEmails/send";
        const token = localStorage.getItem("token");
        if (!token) {
            navigate('/login');
            setIsSendingNow(false);
            setIsScheduling(false);
            return;
        }
        const subject = email?.subject || email?.email_templates?.subject || '';
        const content = email?.content || email?.email_templates?.content || '';
        const subjectPlaceholders = email?.subjectPlaceholders || [];
        const contentPlaceholders = email?.contentPlaceholders || [];
        const formData = new FormData();
        formData.append("subjectPlaceholders", JSON.stringify(subjectPlaceholders));
        formData.append("contentPlaceholders", JSON.stringify(contentPlaceholders));
        formData.append("subject", subject);
        formData.append("content", content);
        if (recipientType === "manual") {
            const emailArray = manualEmails.filter(email => typeof email === "string" && email.trim() !== "");
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const invalidEmails = emailArray.filter(email => !emailRegex.test(email));
            if (emailArray.length === 0) {
                swal("Error!", "Please enter at least one email address.", "error");
                setIsSendingNow(false);
                setIsScheduling(false);
                return;
            }
            if (invalidEmails.length > 0) {
                swal("Error!", `Invalid email: ${invalidEmails.join(", ")}`, "error");
                setIsSendingNow(false);
                setIsScheduling(false);
                return;
            }
            // Convert to CSV
            const manualCSVContent = ["Email", ...emailArray].join("\n");
            const manualCSVBlob = new Blob([manualCSVContent], { type: "text/csv" });
            const manualCSVFile = new File([manualCSVBlob], `manual_recipients_${Date.now()}.csv`, { type: "text/csv" });
            formData.append("file", manualCSVFile);
        } else {
            // File-based recipient list from selectedEmail
            const fileBase64 = selectedEmail?.file;
            if (!fileBase64) {
                swal("Error!", "No recipient CSV found.", "error");
                setIsSendingNow(false);
                setIsScheduling(false);
                return;
            }
            const decodedCSV = atob(fileBase64);
            const csvBlob = new Blob([decodedCSV], { type: "text/csv" });
            const timestamp = Date.now();
            const csvFile = new File([csvBlob], `recipients_${timestamp}.csv`, { type: "text/csv" });
            formData.append("file", csvFile);
        }
        // Schedule time
        let scheduleTime = "now";
        if (scheduleLater) {
            if (!selectedDate || !selectedTime) {
                swal("Error!", "Please select a date and time to schedule the email.", "error");
                setIsSendingNow(false);
                setIsScheduling(false);
                return;
            }
            const combinedDateTime = `${selectedDate.format("YYYY-MM-DD")} ${selectedTime.format("HH:mm:ss")}`;
            const scheduledPST = moment.tz(combinedDateTime, "America/Los_Angeles");
            scheduleTime = scheduledPST.format("YYYY-MM-DDTHH:mm:ss");
        }
        formData.append("scheduleTime", scheduleTime);
        // Send the email
        try {
            const res = await dispatch(postFormData({ apiUrl, formData })).unwrap();
            if (res?.success === true) {
                const successMessage = scheduleLater
                    ? "Email scheduled successfully!"
                    : "Email sent successfully!";
                swal("Success!", successMessage, "success").then(() => {
                    setSelectedReport(null);
                    setManualEmails([]);
                    setOpenEmailPopup(false);
                    fetchSentEmails();
                });
            } else {
                swal("Error!", res?.message || "Failed to send email", "error");
            }
        } catch (error) {
            console.error("Error sending email:", error);
            swal("Error!", "Failed to send email", "error");
        } finally {
            setIsSendingNow(false);
            setIsScheduling(false);
        }
    };

    const [csvRows, setCsvRows] = useState([]);
    const [csvColumns, setCsvColumns] = useState([]);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState("");
    const [confirmAction, setConfirmAction] = useState(() => () => { });
    //  open the confirmation dialog
    const openConfirmation = (message, action) => {
        setConfirmMessage(message);
        setConfirmAction(() => action); // Store  function to SHOW on confirm
        setOpenConfirm(true);
    };
    const handleCloseDialog = () => {
        setOpenEmailPopup(false);
        setSelectedReport(null);
        setCsvRows([]);
        setCsvColumns([]);
        setOpenScheduleSection(false);
        setManualEmails([]);
    };
    const handleViewCSV = () => {
        const file = selectedEmail?.file;
        if (!file) {
            alert("No CSV file found.");
            return;
        }
        try {
            const decoded = atob(file).trim();
            const lines = decoded.split("\n");
            const headers = lines[0].split(",").map(h => h.trim());
            const rows = lines.slice(1).map((line, index) => {
                const values = line.split(",");
                const row = { id: index + 1 };
                headers.forEach((h, i) => {
                    row[h] = values[i]?.trim() || "";
                });
                return row;
            });
            setViewCols(
                headers.map(h => ({
                    field: h,
                    headerName: h,
                    flex: 1,
                    minWidth: 200,
                    renderCell: (params) => (
                        <Box sx={{ wordBreak: "break-word", whiteSpace: "normal", overflow: "hidden" }}>
                            {params.value || "N/A"}
                        </Box>
                    )
                }))
            );
            setViewRows(rows);
            setIsViewRecipientsOpen(true); // This shows the <Dialog> with DataGrid
        } catch (error) {
            console.error("CSV Decode Error:", error);
            alert("Failed to decode recipient data.");
        }
    };

    const ContentLayout =
        <>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Campaigns
                </Typography>
                <Button variant="contained" className="commonBtn" onClick={() => navigate("/email-editor")}>CREATE EMAIL</Button>
            </Box>
            <Tabs value={activeTab} onChange={handleTabChange} TabIndicatorProps={{ style: { backgroundColor: "#2A9005" } }}>
                <Tab label="All Campaigns" sx={{ textTransform: "none", fontWeight: "bold", color: activeTab === 0 ? "#2A9005" : "inherit", "&.Mui-selected": { color: "#2A9005" } }} />
                <Tab label="Saved Email Templates" sx={{ textTransform: "none", fontWeight: "bold", color: activeTab === 1 ? "#2A9005" : "inherit", "&.Mui-selected": { color: "#2A9005" } }} />
            </Tabs>
            {activeTab === 0 && (
                <Box sx={{ width: "100%", mx: "auto", mt: 3 }}>
                    <DataGrid key={sentEmails.length}
                        rows={sentEmails}
                        columns={sentEmailsColumns}
                        getRowId={(row) => row.id}
                        pageSizeOptions={[10, 20, 50]}
                        pagination
                        paginationMode="client"
                        autoHeight
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 10, page: 0 },
                            },
                        }}
                        slots={{ toolbar: GridToolbar }}
                        slotProps={{ toolbar: { showQuickFilter: true } }}
                        density="comfortable"
                        sx={{
                            maxWidth: "100%",
                            "& .MuiDataGrid-columnHeaders": {
                                backgroundColor: "#2E67BC",
                                color: "#fff",
                                fontWeight: "bold"
                            }
                        }}
                        onRowSelectionModelChange={(selectedIds) => {
                            const selectedData = sentEmails.filter(row => selectedIds.includes(row.id));
                            setSelectedRows(selectedData);
                        }}
                    />
                </Box>
            )}
            {activeTab === 1 && (
                <Box sx={{ width: "100%", mx: "auto", mt: 3 }}>
                    <DataGrid
                        rows={savedEmails}
                        columns={savedEmailscolumns}
                        getRowId={(row) => row.id}
                        pageSizeOptions={[10, 20, 50]}
                        pagination
                        paginationMode="client"
                        autoHeight
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 10, page: 0 },
                            },
                        }}
                        slots={{ toolbar: GridToolbar }}
                        slotProps={{ toolbar: { showQuickFilter: true } }}
                        sx={{
                            maxWidth: "100%",
                            "& .MuiDataGrid-columnHeaders": {
                                backgroundColor: "#2E67BC",
                                color: "#fff",
                                fontWeight: "bold"
                            }
                        }}
                        onRowSelectionModelChange={(selectedIds) => {
                            const selectedData = savedEmails.filter(row => selectedIds.includes(row.id));
                            setSelectedRows(selectedData);
                        }}
                    />
                </Box>
            )}
            <Dialog open={openDialog} fullWidth maxWidth="lg">
                <DialogTitle>
                    Email Content
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={() => setOpenDialog(false)}
                        aria-label="close"
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedEmail && selectedEmail.content && selectedEmail.content !== "undefined" ? (
                        <div dangerouslySetInnerHTML={{ __html: selectedEmail.content }} />
                    ) : (
                        <Typography>No content available</Typography>
                    )}
                </DialogContent>
            </Dialog>
            <Dialog open={openEmailPopup} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
                <DialogTitle>
                    Send Email
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={handleCloseDialog}
                        aria-label="close"
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <Box>
                            <Typography variant="subtitle1" sx={{ mb: 1 }}>Select Recipients:</Typography>
                            <RadioGroup
                                row
                                value={recipientType}
                                onChange={(e) => {
                                    const selectedType = e.target.value;
                                    setRecipientType(selectedType);
                                    if (selectedType === "manual") {
                                        setSelectedReport(null);
                                    } else if (selectedType === "report") {
                                        setManualEmails([]);
                                    }
                                }}
                            >
                                <FormControlLabel value="report" control={<Radio />} label="Existing User List" />
                                <FormControlLabel value="manual" control={<Radio />} label="Enter Emails Manually" />
                            </RadioGroup>
                        </Box>
                        {recipientType === "manual" && (
                            <Autocomplete
                                multiple freeSolo options={[]}
                                value={manualEmails}
                                onChange={(event, newValue) => setManualEmails(newValue)}
                                onPaste={(e) => {
                                    e.preventDefault();                                           // Prevent the default paste              
                                    const pastedText = e.clipboardData.getData("text");           // Get the pasted text
                                    const newEmails = pastedText                                  // Split the pasted text by spaces or commas
                                        .split(/[ ,\n]/) // Split by space comma
                                        .map((email) => email.trim()) // Trim spaces around each email
                                        .filter(Boolean); // Remove empty entries                                   
                                    setManualEmails((prevEmails) => [...prevEmails, ...newEmails]);
                                }}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (<Chip variant="outlined" label={option} {...getTagProps({ index })} />))
                                }
                                renderInput={(params) => (
                                    <TextField {...params} label="Enter email addresses"
                                        placeholder="Type or paste emails, press Enter" size="small" variant="outlined" fullWidth
                                    />
                                )}
                            />
                        )}
                        {recipientType === "report" && (
                            <TextField
                                label="To"
                                size="small"
                                variant="outlined"
                                placeholder="Recipient email id"
                                value={csvRows.length > 0 ? `${csvRows.length} Recipient${csvRows.length > 1 ? "s" : ""} Selected` : ""}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleViewCSV}>
                                                <Visibility />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        )}
                        < TextField
                            label="From"
                            size="small"
                            variant="outlined"
                            value="bruce.cornelious@myfreescorenow.com"
                        />
                        <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                            <Button
                                variant="contained"
                                className="send-button"
                                onClick={() => handleSendEmail(false, selectedEmail)}
                                disabled={isSendingNow}
                                startIcon={isSendingNow ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
                            >
                                Send Now
                            </Button>
                            <Button variant="outlined" className="commonOutlinedBtn" onClick={handleScheduleLaterClick}>Schedule for Later</Button>
                        </Box>
                        {openScheduleSection && (
                            <Box sx={{ mt: 1 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Select Date"
                                        value={selectedDate}
                                        disablePast
                                        onChange={(newDate) => setSelectedDate(newDate)}
                                        sx={{ width: "100%", mb: 2 }}
                                    />
                                    <TimePicker
                                        label="Select Time"
                                        value={selectedTime}
                                        onChange={(newTime) => setSelectedTime(newTime)}
                                        sx={{ width: "100%" }}
                                    />
                                </LocalizationProvider>
                                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                    <Button
                                        variant="contained"
                                        className="schedule-button"
                                        onClick={() => handleSendEmail(true, selectedEmail)}
                                        disabled={isScheduling}
                                        startIcon={isScheduling ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
                                    >
                                        Schedule
                                    </Button>
                                    <Button variant="outlined" className="commonOutlinedBtn" onClick={() => setOpenScheduleSection(false)}>Cancel</Button>
                                </Box>
                            </Box>
                        )}
                    </Box>
                </DialogContent>
            </Dialog>
            <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>{confirmMessage}</DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirm(false)} color="primary">Cancel</Button>
                    <Button onClick={() => { confirmAction(); setOpenConfirm(false); }} color="error" variant="contained">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={isViewRecipientsOpen} onClose={() => setIsViewRecipientsOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>
                    Recipient List
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={() => setIsViewRecipientsOpen(false)}
                        aria-label="close"
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box style={{ height: 400, width: "100%" }}>
                        <DataGrid rows={viewRows} columns={viewCols} pageSize={10} sx={{
                            "& .MuiDataGrid-columnHeaders": {
                                backgroundColor: "#2E67BC",
                                color: "#fff",
                                fontWeight: "bold"
                            }
                        }} />
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    return (
        <>
            <DefaultLayout content={ContentLayout} />
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                    onClick={handleFreezStop}
                >
                    <Freez />
                </Backdrop>
            </div></>
    );

};

export default Campaigns;